import axios from 'axios';
let BASE_URL 
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
 //BASE_URL = "http://192.168.1.112:3000/";
 BASE_URL = "http://localhost:3000/";
}else{
    
  //BASE_URL = "http://localhost:3000/";
  BASE_URL = "https://forestlogbook.herokuapp.com/";
}
const withCredentials = true;
const credentials = "include";
class API{
    constructor(){
        this.doLogin = this.doLogin.bind(this);     
    }


    doConnectionTest(callBackSuccess,callBackError){
        let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
        client.get(BASE_URL +"api/")
        .then(
          (result) => {
            callBackSuccess("");
          },

          (error) => {
              callBackError("Ei yhteyttä palvelimeen");
         
        }
        );
    }
    doLogin(user,callBackSuccess,callBackError){
        let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
        client.post(BASE_URL +"doLogin","username=" + user.username +"&password=" + user.password,{headers: { userMessagingToken: window.localStorage.getItem("userMessagingToken")}})
        .then(
          (result) => {
            callBackSuccess(result.data);
          },

          (error) => {
              callBackError("Kirjautuminen epäonnistui!");
         
        }
        );
    }


    registerWorker(accessToken,callBackSuccess,callBackError){
      let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
      client.get(BASE_URL +"api/registerWorker", {headers: {"WorkerAccessToken": accessToken}})
      .then(
        (result) => {
          callBackSuccess(result.data.newAccessToken);
        },

        (error) => {
          
            callBackError(accessToken);
       
      }
      );
  }
  isValidToken(accessToken,callBackSuccess,callBackError){
    let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
    client.get(BASE_URL +"api/isValidToken", {headers: {"WorkerAccessToken": accessToken,userMessagingToken: window.localStorage.getItem("userMessagingToken")}})
    .then(
      (result) => {
        callBackSuccess(result.data.newAccessToken);
      },

      (error) => {
        
          callBackError(error.message);
     
    }
    );
}
  


    startWorking(callBackSuccess,callBackError){
        let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
        client.get(BASE_URL +"api/startWorking", {headers: {"WorkerAccessToken": (window.localStorage.accessToken)}})
        .then(
          (result) => {
            callBackSuccess();
          },

          (error) => {
              callBackError("Kirjaudu uudelleen!");
         
        }
        );
    }


   

    stopWorking(callBackSuccess,callBackError){
        let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
        client.get(BASE_URL +"api/stopWorking", {headers: {"WorkerAccessToken": (window.localStorage.accessToken)}})
        .then(
          (result) => {
            callBackSuccess();
          },

          (error) => {
              callBackError("Kirjaudu uudelleen!");
         
        }
        );
    }

    createNewTokenForWorker(worker,callBackSuccess,callBackError){
      let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
      client.post(BASE_URL +"api/createNewTokenForWorker",worker)
      .then(
        (result) => {
          callBackSuccess(result.data.newAccessToken);
        },

        (error) => {
            
          callBackError(error.message);
       
      }
      );
  }


    saveWorker(worker,callBackSuccess,callBackError){
        let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
        client.post(BASE_URL +"api/saveWorker",worker)
        .then(
          (result) => {
            callBackSuccess(result.data);
          },

          (error) => {
              callBackError("Kirjaudu uudelleen!");
         
        }
        );
    }
    saveUser(user,callBackSuccess,callBackError){
      let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
      client.post(BASE_URL +"api/saveUser",user)
      .then(
        (result) => {
          callBackSuccess(result.data);
        },

        (error) => {
            callBackError("Kirjaudu uudelleen!");
       
      }
      );
  }

    
    changePassword(oldPass,newPass,callBackSuccess,callBackError){
      let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
      client.post(BASE_URL +"api/changepass",{oldpassword:oldPass,newpassword:newPass})
      .then(
        (result) => {
          callBackSuccess(result.data);
        },

        (error) => {
            callBackError("Kirjaudu uudelleen!");
       
      }
      );
  }

    deleteWorker(worker,callBackSuccess,callBackError){
        let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
        client.post(BASE_URL +"api/deleteWorker",worker)
        .then(
          (result) => {
            callBackSuccess();
          },

          (error) => {
              callBackError("Kirjaudu uudelleen!");
         
        }
        );
    }

     
    saveWorkerLocation(location,callBackSuccess,callBackError){
      let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
      let locationToSend = {location:location};
      client.post(BASE_URL +"api/saveWorkerLocation",locationToSend,{headers: {"WorkerAccessToken": (window.localStorage.accessToken)}})
      .then(
        (result) => {
          callBackSuccess(result);
        },

        (error) => {
            callBackError("Kirjaudu uudelleen!");
       
      }
      );
  }


  getUsers(callBackSuccess,callBackError){
    let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
    client.get(BASE_URL +"api/users")
    .then(
      (result) => {
        callBackSuccess(result.data.users);
      },

      (error) => {
          callBackError("Kirjaudu uudelleen!");
     
    }
    );
}

savePostingAndCreateNewToken(posting,callBackSuccess,callBackError){
  console.log("savePosting");
  console.log(posting);
  let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
  client.post(BASE_URL +"api/savePosting?createNewToken=true",posting)
  .then(
    (result) => {
      callBackSuccess(result.data);
    },

    (error) => {
        callBackError("Kirjaudu uudelleen!");
   
  }
  );
}

 savePosting(posting,callBackSuccess,callBackError){
  console.log("savePosting");
  console.log(posting);
  let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
  client.post(BASE_URL +"api/savePosting",posting)
  .then(
    (result) => {
      callBackSuccess(result.data);
    },

    (error) => {
        callBackError("Kirjaudu uudelleen!");
   
  }
  );
}
deletePosting(posting,callBackSuccess,callBackError){
  let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
  client.post(BASE_URL +"api/deletePosting",posting)
  .then(
    (result) => {
      callBackSuccess(result.data);
    },

    (error) => {
        callBackError("Kirjaudu uudelleen!");
   
  }
  );
}


getPostings(callBackSuccess,callBackError){
  let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});

  client.get(BASE_URL +"api/postings")
  .then(
    (result) => {
      callBackSuccess(result.data.postings);
    },

    (error) => {
        callBackError("Kirjaudu uudelleen!");
   
  }
  );
}

sendTestMessageToUser(user,callBackSuccess,callBackError){
  let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
  client.get(BASE_URL +"api/sendTestMessageToUser?username=" + user.username)
  .then(
    (result) => {
      callBackSuccess("Viesti lähetetty");
    },

    (error) => {
        callBackError("Virhe lähettäessä viestiä:" + error.message);
   
  }
  );
}

    getWorkers(callBackSuccess,callBackError){
        let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
        client.get(BASE_URL +"api/workers")
        .then(
          (result) => {
            callBackSuccess(result.data.workers);
          },

          (error) => {
              callBackError("Kirjaudu uudelleen!");
         
        }
        );
    }

    
    notifyWorker(callBackSuccess,callBackError){
      let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
      client.get(BASE_URL +"api/notifyWorker",{headers: {"WorkerAccessToken": (window.localStorage.accessToken)}})
      .then(
        (result) => {
          callBackSuccess(result.data.playSound);
        },

        (error) => {
            callBackError();
       
      }
      );
  }

    
  notifyForeman(callBackSuccess,callBackError){
    let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
    client.get(BASE_URL +"api/notifyForeman")
    .then(
      (result) => {
        callBackSuccess(result.data.playSound);
      },

      (error) => {
        
        console.log("Notify error");
          callBackError();
     
    }
    );
}

     

    saveTimeConfig(timeConfig,callBackSuccess,callBackError){
        let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
        client.post(BASE_URL +"api/saveConfig",timeConfig)
        .then(
          (result) => {
            callBackSuccess();
          },

          (error) => {
              callBackError("Kirjaudu uudelleen!");
         
        }
        );
    }

    getTimeConfig(callBackSuccess,callBackError){
        let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
        client.get(BASE_URL +"api/config")
        .then(
          (result) => {
            callBackSuccess(result.data.timeConfig);
          },

          (error) => {
              callBackError("Kirjaudu uudelleen!");
         
        }
        );
    }

    isAuthenticated(callBackSuccess,callBackError){
        let client = axios.create({ withCredentials: withCredentials },{ credentials: credentials, crossdomain: true});
        client.get(BASE_URL +"api/isAuthenticated",{headers:{userMessagingToken: window.localStorage.getItem("userMessagingToken")}})
        .then(
          (result) => {
            callBackSuccess(result.data);
          },

          (error) => {
              callBackError("Kirjautuminen epäonnistui!");
         
        }
        );
    }

}




export default API;
export const BASEURL = BASE_URL;